import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import Title from '~/src/feature/toyono/components/Title';
import AccessDirection from '~/src/feature/toyono/components/AccessDirection';
import ToyonochouImage from '../../../../images/features/toyono/toyonochou.png';
import trainIcon from '../../../../images/features/toyono/train.png';
import carIcon from '../../../../images/features/toyono/car.png';

const useStyles = makeStyles((theme) => ({
  descriptionText: {
    letterSpacing: '1px',
    lineHeight: 1.8,
  },
  separation: {
    marginBottom: theme.spacing(3),
  },
}));

const Container = styled.div<{ theme: Theme }>`
  padding: ${({ theme }) => theme.spacing(4, 0, 2)};
  margin: auto;
  width: 100%;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: ${({ theme }) => theme.spacing(10, 0)};
    max-width: 1200px;
  }
`;

const Description = styled.div`
  width: 90%;
  margin: ${({ theme }) => theme.spacing(0, 'auto', 5)};
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: flex;
  }
`;

const DescriptionText = styled.div<{ theme: Theme }>`
  text-align: left;
  position: relative;
  padding: ${({ theme }) => theme.spacing(0, 0, 3)};
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 680px;
    padding: ${({ theme }) => theme.spacing(12, 0, 0)};
  }
`;

const Img = styled.img<{ theme: Theme }>`
  width: 80%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 295px;
    width: 25%;
    height: auto;
    margin: 5% 10% 0 5%;
  }
`;

interface Props {}

const Access: VFC<Props> = () => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Container theme={theme}>
      <Title text="ACCESS">豊能町へのアクセス</Title>
      <Description theme={theme}>
        <DescriptionText theme={theme}>
          <Typography className={classes.descriptionText}>
            豊能町は町内でも東西で交通網が分かれており、妙見口方面か、牧・余野方面に向かうかによって、アクセス方法が変わってきます。
          </Typography>
          <Typography className={classes.descriptionText}>
            お越しの際はどちらの方面に向かうかご確認してお越しください
          </Typography>
        </DescriptionText>
        <Img src={ToyonochouImage} theme={theme} alt="豊能町" />
      </Description>
      <AccessDirection
        icon={trainIcon}
        title="公共交通機関の場合"
        leftText={
          <>
            <Typography>
              阪急電車「川西能勢口駅」で能勢電鉄に乗り換え、「妙見口駅」下車
            </Typography>
          </>
        }
        rightText={
          <>
            <Typography>
              阪急電車「池田駅」下車、阪急バス池田駅発西乗り場「余野・牧」行き乗車
            </Typography>
          </>
        }
      />
      <AccessDirection
        icon={carIcon}
        title="車利用の場合"
        leftText={
          <>
            <Typography>【大阪方面から】</Typography>
            <Typography>
              阪神高速木部出口を降り国道173号線から477号線を北上
            </Typography>
          </>
        }
        rightText={
          <>
            <Typography>【大阪方面から】</Typography>
            <Typography>阪神高速木部出口を降り国道423号線を北上</Typography>
            <Typography>
              新御堂筋萱野より箕面グリーンロードを抜け国道423号線を北上
            </Typography>
            <Typography>【京都方面から】</Typography>
            <Typography>
              京都縦貫亀岡出口を降りて国道372号線から477号線を南下
            </Typography>
            <Typography>京都縦貫亀岡出口を降りて国道423号線を南下</Typography>
          </>
        }
      />
    </Container>
  );
};

export default Access;
